<div class="row">
  <div class="col-2">
    <div style="width:50%; margin-top:2vh;"><button mat-raised-button color="primary" style="margin-left: 2vw" (click)="openDialog()" >{{'IRIDIUM.FETCH_DATA' | translate}}</button></div> 
  </div>
    <div class="col-3" style="margin-top:2vh;"> 
      <div>
        <ul>
          <li><b>LLuviaDecAlarma:</b>  Alarma generada por alerta de lluvia con los siguientes umbrales
            <ul>
              <li><b>Río Biobio en Puente Piulo:</b> 50 mm en menos de una hora</li>
              <li><b>Río Biobio en La Culebra:</b> 50mm en menos de una hora</li>
              <li><b style="background-color: rgb(255, 255, 130);">Río Huequecura Aguas Arriba de Embalse Angostura:</b> 30mm en menos de una hora (actualmente configurado como 50mm)</li>
            </ul>
          </li>
          <li><b>LluviaContAlarma:</b> Alarma 5 minutal durante 1 hora tras detectarse alarma por lluvia</li>
        </ul>

        <hr>
        <span>NOTA: Los tags DGA / CLB en las mediciones corresponden a:</span>
        <ul>
          <li><b>DGA:</b> Medidas que son almacenadas para el envío a través de la red GOES</li>
          <li><b>CLB:</b> Medidas que son almacenadas para el envío a través de la red IRIDIUM</li>
        </ul>
      </div>
    </div>
    <div class="col-3" style="margin-top:2vh;">
      <div>
        <ul>
          <li> <b>NivelAlarmID:</b> Alarma emitida por caudal de río fuera de rango.</li>
          <ul>
            <li><b>Río Biobio en Puente Piulo:</b> 
              <ol>
                <li><b>Alarma por incremento:</b> Alarma tras detectar caudal superior a 800m<sup>3</sup>/s (Altura de 6.03 metros)</li>
                <li><b>Alarma por decremento:</b> Alarma tras detectar caudal inferior a 82.22m<sup>3</sup>/s (Altura de 1.06 metros)</li>
              </ol>
            </li>
            <li><b>Río Biobio en La Culebra:</b> 
              <ol>
                <li><b>Alarma por incremento:</b> Alarma tras detectar caudal superior a 670m<sup>3</sup>/s (Altura de 3.42 metros)</li>
                <li><b>Alarma por decremento:</b> Alarma tras detectar caudal inferior a 82.22m<sup>3</sup>/s (Altura de 1.06 metros)</li>
              </ol>
            </li>
            <li><b> Río Huequecura Aguas Arriba de Embalse Angostura:</b> 
              <ol>
                <li><b>Alarma por incremento:</b> Alarma tras detectar caudal superior a 100m<sup>3</sup>/s (Altura de 1.15 metros)</li>
                <li><b>Alarma por decremento:</b> No se necesita</li>
              </ol>
            </li>
          </ul>
          <li><b>NivelContAlarmID:</b> Alarma 5 minutal durante 1 hora tras detectar una alarma por caudal</li>
        </ul>
      </div>
    </div>
    <div class="col-3" style="margin-top:2vh;">
      <div>
        <ul>
          <li> <b>RandomID:</b> Envío diario de las estaciones (no es una alarma) </li>
        </ul>
      </div>
    </div>
</div>

<!-- 
<mat-form-field class="filtro-tabla">
  <mat-label>Filtrar</mat-label>
  <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar datos...">
</mat-form-field> -->

<hr style="width:85%; margin-left: 2vw;margin-top:3vh;" />

<div class="mat-elevation-z8" style="width:85%; margin-left: 2vw;margin-top:3vh;" align="center" [hidden]="loading" >
    <br />
    <h3><b>{{'IRIDIUM.HEADER.INFO' | translate}}</b></h3>
    <table mat-table [dataSource]="dataSourceIridium"> 
      
      <ng-container matColumnDef="dataCreated">
        <th mat-header-cell *matHeaderCellDef> <b>{{'IRIDIUM.EVENTS.CREATED_DATE' | translate}}</b></th>
        <td mat-cell *matCellDef="let d"> {{d.dateCreated}}  </td>
      </ng-container>
<!-- 
      <ng-container matColumnDef="imei">
        <th mat-header-cell *matHeaderCellDef> <b>{{'IRIDIUM.EVENTS.IMEI' | translate}}</b></th>
        <td mat-cell *matCellDef="let d"> {{d.msg.imei}} </td>
      </ng-container> -->

      <ng-container matColumnDef="dispositivo">
        <th mat-header-cell *matHeaderCellDef> <b>{{'IRIDIUM.EVENTS.DEVICE' | translate}}</b></th>
        <td mat-cell *matCellDef="let d"> {{d.findDispositivoByImei[0].nombre}} </td>
      </ng-container>

      <ng-container matColumnDef="tag">
        <th mat-header-cell *matHeaderCellDef> <b>{{'IRIDIUM.EVENTS.TAG' | translate}}</b></th>
        <td mat-cell *matCellDef="let d"> 
          <ng-container *ngIf="d.msg.payload.valores && d.msg.payload.valores.length==1;">
            {{'DATA_TYPES_AND_AGRUPATIONS.'.concat(d.msg.payload.valores[0].tag) | translate}}
          </ng-container>
          <ng-container *ngIf="( d.msg.payload.valores && d.msg.payload.valores.length==2) || d.msg.payload.alarmas">
            {{'IRIDIUM.EVENTS.AUTOMATIC_ALARM' | translate}}
          </ng-container>
          
      </ng-container>

      <ng-container matColumnDef="valor">
        <th mat-header-cell *matHeaderCellDef> <b>{{'IRIDIUM.EVENTS.VALOR' | translate}}</b></th>
        <td mat-cell *matCellDef="let d"> 
          <ng-container *ngIf="d.msg.payload.valores && d.msg.payload.valores.length == 1; else elseValorAlarma">
            {{d.msg.payload.valores[0].valor }}
          </ng-container>
          <ng-template #elseValorAlarma>
            <div *ngIf="d.msg.payload.valores && d.msg.payload.valores.length == 2">
              <ng-container *ngFor="let r of d.msg.payload.valores">
                <p> {{'DATA_TYPES_AND_AGRUPATIONS.'.concat(r.tag) | translate}}: {{ r.valor}} </p>
              </ng-container>
            </div>
            <div *ngIf="d.msg.payload.alarmas">
              <p>{{'DATA_TYPES_AND_AGRUPATIONS.lluvia' | translate}}: {{d.msg.payload.alarmas?.lluvia }}  </p>
              <p>{{'DATA_TYPES_AND_AGRUPATIONS.altlm'  | translate}}: {{d.msg.payload.alarmas?.altlm }}  </p>
            </div>
          </ng-template>
      </ng-container>

      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef> <b>{{'IRIDIUM.EVENTS.TIPO' | translate}}</b></th>
        <td mat-cell *matCellDef="let d"> 
          {{((d.msg.payload.alarmas?.tipo!= null) ? d.msg.payload.alarmas?.tipo : (d.msg.payload.valores?.length == 2) ? 'RandomID' : 'IRIDIUM.MODE.MANUAL_DATA') | translate}}
        </td>
      </ng-container>


      <ng-container matColumnDef="unidad">
        <th mat-header-cell *matHeaderCellDef> <b>{{'IRIDIUM.EVENTS.UNIT' | translate}}</b></th>
        <td mat-cell *matCellDef="let d"> 
          <ng-container *ngIf="d.msg.payload.valores && d.msg.payload.valores.length == 1; else elseUnidadManual">
            <span *ngIf="d.msg.payload.valores[0].findTipoDatoByTag">{{d.msg.payload.valores[0].findTipoDatoByTag[0].unidad}}</span>
            <span *ngIf="!d.msg.payload.valores[0].findTipoDatoByTag && d.msg.payload.valores[0].findTipoDatoByTag[0].uuid!=null"> {{'IRIDIUM.NO_DATATYPE' | translate }}</span>
          </ng-container>
          <ng-template #elseUnidadManual>
            <p>mm </p>
            <p>cm </p>
          </ng-template>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsIridium"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsIridium;" 
      [ngClass]="[(alarmsId5Minutales.indexOf(row.msg.payload.alarmas?.tipo) > -1) ? 'trContAlarm' : '',
                  (alarmsID.indexOf(row.msg.payload.alarmas?.tipo) > -1) ? 'trAlarm' : '' ]" ></tr> 
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 25]" showFirstLastButtons></mat-paginator>
</div>

